import { render } from "./AIWelcomeMessage.vue?vue&type=template&id=205ce7e3&scoped=true"
import script from "./AIWelcomeMessage.vue?vue&type=script&lang=js"
export * from "./AIWelcomeMessage.vue?vue&type=script&lang=js"

import "./AIWelcomeMessage.vue?vue&type=style&index=0&id=205ce7e3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205ce7e3"]])

export default __exports__